// Tabs — an underline tab strip. Controlled: you own the active key.
// Accessible (role=tablist/tab, aria-selected, arrow-key friendly via native
// buttons). Optional per-tab count chip.
//
//   const [tab, setTab] = useState('active');
//   <Tabs
//     value={tab}
//     onChange={setTab}
//     tabs={[
//       { key: 'active', label: 'Active', count: 12 },
//       { key: 'pending', label: 'Pending', count: 3 },
//       { key: 'open', label: 'Open Requisitions' },
//     ]}
//   />

import { ReactNode } from 'react';

export interface TabItem {
  key: string;
  label: ReactNode;
  count?: number;
  icon?: ReactNode;
}

export interface TabsProps {
  value: string;
  onChange: (key: string) => void;
  tabs: TabItem[];
  className?: string;
  'aria-label'?: string;
}

export default function Tabs({ value, onChange, tabs, className, ...aria }: TabsProps) {
  return (
    <div className={['ui-tabs', className].filter(Boolean).join(' ')} role="tablist" aria-label={aria['aria-label']}>
      {tabs.map((t) => {
        const active = t.key === value;
        return (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={active}
            className={['ui-tab', active ? 'ui-tab--active' : ''].filter(Boolean).join(' ')}
            onClick={() => onChange(t.key)}
          >
            {t.icon}
            {t.label}
            {t.count != null && <span className="ui-tab__count">{t.count}</span>}
          </button>
        );
      })}
    </div>
  );
}
